import React, { useState } from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Button } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import PortfolioProject from './PortfolioProject/PortfolioProject';

const WorkPortfolio = ({ projects }) => {

  const [curIndex, setCurIndex] = useState(0);

  if (projects.length < 1) {
    return null;
  }

  const handlePrev = () => {
    const prev = curIndex - 1 > -1 ? curIndex - 1 : curIndex;
    setCurIndex(prev);
  };

  const handleNext = () => {
    const next = curIndex + 1 < projects.length ? curIndex + 1 : curIndex;
    setCurIndex(next);
  };

  const showPrev = () => curIndex !== 0;
  const showNext = () => curIndex !== projects.length - 1;

  return (
    <section className="p2p-portfolio__root">
      <div className="p2p-portfolio__controls">
        <Button
          className="p2p-portfolio__project-prev"
          data-testid="portfolio-prev-project-btn"
          onClick={handlePrev}
          disabled={!showPrev()}
          outline
          inline
        >
          <ChevronLeftIcon fontSize="large" />
          Previous Project
        </Button>
        <Button
          data-testid="portfolio-next-project-btn"
          onClick={handleNext}
          disabled={!showNext()}
          outline
          inline
        >
          Next Project
          <ChevronRightIcon fontSize="large" />
        </Button>
      </div>
      <h2>{projects[curIndex].title}</h2>
      <PortfolioProject key={curIndex} data={projects[curIndex]} />
    </section>
  );
};

export default WorkPortfolio;

WorkPortfolio.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      files: PropTypes.shape({
        images: PropTypes.arrayOf(PropTypes.string),
        videos: PropTypes.arrayOf(PropTypes.shape({
          type: PropTypes.oneOf(['youtube', 'vimeo', '']),
          id: PropTypes.string
        }))
      }),
      title: PropTypes.string
    })).isRequired
};
